import React, { useMemo } from 'react';
import { ArrowDown, Copy, MessageSquare, Plus, RefreshCw } from 'lucide-react';

export function AIIslandActionBar({ response, actions, labels = {} }) {
  const availableActions = useMemo(() => {
    const base = [
      { id: 'copy', label: labels.copy || 'Copy', icon: Copy, handler: actions.copy },
      {
        id: 'regenerate',
        label: labels.regenerate || 'Regenerate',
        icon: RefreshCw,
        handler: actions.regenerate,
      },
    ];

    if (response.type === 'rewrite') {
      return [
        {
          id: 'replace',
          label: labels.replace || 'Replace selection',
          icon: RefreshCw,
          handler: actions.replace,
          primary: true,
        },
        {
          id: 'insert-below',
          label: labels.insertBelow || 'Insert below',
          icon: ArrowDown,
          handler: actions.insertBelow,
        },
        ...base,
      ];
    }

    return [
      {
        id: 'insert-cursor',
        label: labels.insertAtCursor || 'Insert at cursor',
        icon: Plus,
        handler: actions.insertAtCursor,
        primary: true,
      },
      {
        id: 'insert-below',
        label: labels.insertBelow || 'Insert below',
        icon: ArrowDown,
        handler: actions.insertBelow,
      },
      {
        id: 'comment',
        label: labels.addComment || 'Add as comment',
        icon: MessageSquare,
        handler: actions.addComment,
      },
      ...base,
    ];
  }, [actions, labels, response.type]);

  return (
    <div className="ai-island-actions">
      {availableActions.filter((action) => typeof action.handler === 'function').map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.id}
            type="button"
            className={`ai-island-actions__button${
              action.primary ? ' ai-island-actions__button--primary' : ''
            }`}
            onClick={action.handler}
          >
            <Icon size={14} />
            {action.label}
          </button>
        );
      })}
    </div>
  );
}
